<template>
  <v-dialog :value="value" @input="$emit('input', $event)" persistent :max-width="width" @keydown.esc="close">
    <v-card>
      <v-card-title class="text-h6">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="message || $slots.default">
        <p v-if="message" class="mb-0">{{ message }}</p>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="confirmColor" :outlined="$vuetify.theme.dark" @click="$emit('confirm')" :loading="loading" :disabled="disableConfirm">
          {{ confirmText || $t('common.confirm') }}
        </v-btn>
        <v-btn color="tertiary" class="ms-2" outlined @click="close">
          {{ $t('common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default() {
        return this.$t('common.confirm')
      },
    },
    message: {
      type: [String, null],
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    confirmColor: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disableConfirm: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '440px',
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
